import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Form from "components/form/Form";
import FormLayout from "components/form/FormLayout";
import Sheet from "components/sheet/Sheet";
import Input from "components/form/input/Input";
import { Select as SelectNew, Select } from "components/select/";

import { StatusCode } from "api/protocols";
import { useAppDispatch } from "hooks/redux";
import { showError, showSuccess } from "redux/actions/ui";

type PrizeAccountProps = {
  open: boolean;
  onClose: () => void;
  onOk: (amount: string) => Promise<void>;
};

interface IPrizeAccountAdjust {
  amount: string;
}
export default function PrizeAccountAdjustmentModal(props: PrizeAccountProps) {
  const { open, onClose, onOk } = props;
  const { t } = useTranslation();
  const [prizeAdjustState, setPrizeAdjustState] = useState<IPrizeAccountAdjust>({
    amount: "",
  });

  function resetAdjustmentModal() {
    setPrizeAdjustState({ amount: "" });
  }

  function handleChangeAdjustmentValue(event: React.ChangeEvent<HTMLInputElement>) {
    const { id, value } = event.target;
    setPrizeAdjustState(prevState => ({ ...prevState, [id]: value }));
  }

  return (
    <Sheet
      open={open}
      title={t("Adjust Prize Account Balance")} // TODO: Translation
      onCancel={handleOnClose}
      onOk={() => onOk(prizeAdjustState.amount)}
      size="small"
      height="flexible"
      closable
    >
      <Form>
        <FormLayout>
          <FormLayout.Group>
            <Input
              label={t("Amount")} // TODO: Translation
              type="number"
              id="amount"
              value={prizeAdjustState.amount}
              // defaultValue={prizeAdjustState.amount}
              onChange={handleChangeAdjustmentValue}
            />
          </FormLayout.Group>
        </FormLayout>
      </Form>
    </Sheet>
  );

  function handleOnClose() {
    void resetAdjustmentModal();
    void onClose();
  }
}
